export type { ExceptionParam } from "@src/features/alarms/types/exception-param";
import type { ExceptionParam } from "@src/features/alarms/types/exception-param";

export const pendingExceptionDetailUpdate: { current: ExceptionParam | null } = { current: null };
